/* Product page behavior: gallery, qty stepper, variant sync, sticky bar and
   server-rendered recommendations. Details panels are native <details>, so
   they need no script. */
(function () {
  /* gift card recipient: fields only submit when the toggle is on; Shopify needs the
     buyer's timezone offset to send on the chosen day */
  var gift = document.querySelector('[data-gift-recipient]');
  if (gift) {
    var toggle = gift.querySelector('[data-gift-toggle]');
    var fields = gift.querySelector('[data-gift-fields]');
    var offset = gift.querySelector('[data-gift-offset]');
    var email = gift.querySelector('[data-gift-email]');
    var sendOn = gift.querySelector('[data-gift-send-on]');
    var sync = function () {
      var on = toggle.checked;
      fields.hidden = !on;
      Array.prototype.forEach.call(fields.querySelectorAll('input, textarea'), function (el) { el.disabled = !on; });
      if (email) email.required = on;
      if (offset) { offset.disabled = !on; offset.value = new Date().getTimezoneOffset().toString(); }
    };
    if (sendOn) {
      var today = new Date(); today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
      sendOn.min = today.toISOString().slice(0, 10);
      var limit = new Date(today); limit.setDate(limit.getDate() + 90); // Shopify schedules up to 90 days ahead
      sendOn.max = limit.toISOString().slice(0, 10);
    }
    toggle.addEventListener('change', sync);
    sync();
  }

  var form = document.getElementById('ProductForm');
  var jsonEl = document.querySelector('[data-product-json]');

  // ---- qty stepper (main form + sticky bar share the form's quantity input)
  function qtyInput() {
    return form ? form.querySelector('input[name="quantity"]') : null;
  }
  function setQty(val) {
    var input = qtyInput();
    if (!input) return;
    input.value = Math.max(1, val || 1);
    var display = document.querySelector('[data-sticky-qty]');
    if (display) display.textContent = input.value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus], [data-sticky-minus]');
    var plus = e.target.closest('[data-qty-plus], [data-sticky-plus]');
    if (!minus && !plus) return;
    var input = qtyInput();
    if (!input) return;
    setQty(parseInt(input.value || '1', 10) + (plus ? 1 : -1));
  });
  if (form) {
    var qi = qtyInput();
    if (qi) qi.addEventListener('input', function () { setQty(parseInt(qi.value || '1', 10)); });
  }

  // ---- gallery: thumbs switch the active slide on desktop; on phones the
  // track scrolls and the dots follow it
  (function () {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.lum-pdp__slide'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dots] span'));
    if (slides.length < 2) return;

    function mobile() { return window.matchMedia('(max-width: 1023px)').matches; }
    function activate(i) {
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
        t.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-thumb'), 10);
        if (mobile()) {
          slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        } else {
          activate(i);
        }
      });
    });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!mobile() || ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
        ticking = false;
      });
    }, { passive: true });
  })();

  // ---- sticky Add to Cart bar — appears when the main button leaves the viewport
  (function () {
    var bar = document.getElementById('StickyAtcBar');
    var target = form ? form.querySelector('button[type="submit"]') : document.querySelector('.lum-pdp__gate a');
    if (!bar || !target) return;
    function headerHeight() {
      var nav = document.querySelector('header, .sticky');
      return (nav && nav.offsetHeight) || 0;
    }
    var ticking = false;
    function check() {
      var rect = target.getBoundingClientRect();
      // show once the button has scrolled up out of view; not while it is still below the fold
      var passed = rect.bottom < headerHeight() + 4;
      bar.classList.toggle('is-shown', passed);
      bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
      bar.inert = !passed;
      var chat = document.querySelector('shopify-chat');
      if (chat) {
        chat.style.transition = 'transform 0.3s ease-out';
        chat.style.transform = passed ? 'translateY(-' + (bar.offsetHeight + 8) + 'px)' : '';
      }
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { check(); ticking = false; });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();
  })();

  // ---- variant sync
  if (form && jsonEl) {
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { product = null; }
    if (product) {
      var details = {}, detailJson = document.querySelector('[data-product-variant-details]');
      try { details = JSON.parse(detailJson ? detailJson.textContent : '{}'); } catch (e) {}
      var selects = form.querySelectorAll('[data-option-index]');
      var idInput = form.querySelector('[data-variant-id]');
      var priceEl = document.getElementById('ProductPrice');
      var stockEl = document.getElementById('ProductStock');
      var button = form.querySelector('button[type="submit"]');
      var label = form.querySelector('[data-add-label]');
      function money(cents) {
        var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'CAD';
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style: 'currency', currency: currency}).format(cents / 100); }
        catch (e) { return '$' + (cents / 100).toFixed(2); }
      }
      function sync() {
        var chosen = [];
        selects.forEach(function (s) { chosen[parseInt(s.getAttribute('data-option-index'), 10)] = s.value; });
        var v = product.variants.find(function (x) {
          return x.options.every(function (opt, i) { return opt === chosen[i]; });
        });
        if (!v) {
          if (button) button.disabled = true;
          if (label) label.textContent = 'Unavailable';
          if (idInput) idInput.value = '';
          var invalidSticky = document.querySelector('[data-sticky-add]'); if (invalidSticky) invalidSticky.disabled = true;
          return;
        }
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        var detail = details[String(v.id)] || {};
        var selectedVariant = document.querySelector('[data-pdp-selected-variant]'); if (selectedVariant) selectedVariant.textContent = v.title === 'Default Title' ? '' : v.title;
        document.querySelectorAll('[data-pdp-shipping-note]').forEach(function (el) { el.textContent = detail.shippingNote || ''; el.hidden = !detail.shippingNote; });
        var compare = document.querySelector('[data-pdp-compare]'), sale = document.querySelector('[data-pdp-sale]'), unit = document.querySelector('[data-pdp-unit]');
        var onSale = v.compare_at_price > v.price;
        if (compare) { compare.hidden = !onSale; compare.textContent = onSale ? money(v.compare_at_price) : ''; }
        if (sale) sale.hidden = !onSale;
        if (unit) { unit.hidden = !detail.unitName; unit.textContent = detail.unitName ? detail.unitPrice + ' / ' + (Number(detail.unitReference) !== 1 ? detail.unitReference : '') + detail.unitName : ''; }
        document.querySelectorAll('[data-pdp-local-only],[data-pdp-local-summary]').forEach(function (el) { el.hidden = !detail.localOnly; });
        document.querySelectorAll('[data-pdp-parcel]').forEach(function (el) { el.hidden = !!detail.localOnly; });
        var variantUrl = new URL(window.location.href); variantUrl.searchParams.set('variant', v.id);
        window.history.replaceState(window.history.state, '', variantUrl.toString());
        if (stockEl) {
          stockEl.classList.toggle('is-in', v.available);
          stockEl.classList.toggle('is-out', !v.available);
          stockEl.lastChild.textContent = v.available ? 'In stock online' : 'Out of stock online';
        }
        if (button) button.disabled = !v.available;
        if (label) label.textContent = v.available ? 'Add to cart' : 'Out of stock';
        document.querySelectorAll('[data-pdp-sold-out-alternatives],[data-pdp-sold-out-help]').forEach(function (el) { el.hidden = !!v.available; });
        // urgency and back in stock follow the variant
        var left = document.querySelector('[data-pdp-left]'), leftN = document.querySelector('[data-pdp-left-n]');
        if (left) { var n = detail.left; var show = v.available && typeof n === 'number' && n > 0 && n <= 5; left.hidden = !show; if (leftN && show) leftN.textContent = String(n); }
        if (window.lumMergeLeft) window.lumMergeLeft();
        var bis = document.querySelector('[data-pdp-bis]'); if (bis) { bis.hidden = !!v.available; var bf = bis.querySelector('[data-bis-form]'); if (bf) bf.dataset.variant = String(v.id); }
        if (window.lumShipLine) window.lumShipLine(v.price, !!detail.localOnly, !!v.available);
        var pts = document.querySelector('[data-pdp-points]'), ptsN = document.querySelector('[data-pdp-points-n]');
        if (pts) { pts.hidden = !v.available; if (ptsN) ptsN.textContent = String(Math.floor(v.price / 100)); }
        var stickyPrice = document.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = money(v.price);
        var stickyVariant = document.querySelector('[data-sticky-variant]');
        if (stickyVariant && v.title !== 'Default Title') stickyVariant.textContent = v.title;
        var stickyAdd = document.querySelector('[data-sticky-add]');
        if (stickyAdd) stickyAdd.disabled = !v.available;
      }
      selects.forEach(function (s) { s.addEventListener('change', sync); });
    }
  }

  // ---- back in stock: the form is handled by lum-bis.js (shared with the cards)

  // ---- recommendations: the product-recommendations section rendered by
  // Shopify with the site's own product card, dropped in below the details
  var reco = document.querySelector('[data-recommendations]');
  if (reco && reco.dataset.url) {
    fetch(reco.dataset.url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.shopify-section');
        if (!section || !section.querySelector('.lum-rail__item')) return;
        reco.innerHTML = section.innerHTML;
        reco.hidden = false;
      })
      .catch(function () {});
  }
})();


/* ---- Urgency that is true (27 Oct 2026): the free-delivery line from the cart and the
   same-day cut-off from Halifax time. Shown to local shoppers via html.lum-local. ---- */
(function () {
  var box = document.querySelector('[data-pdp-urgency]'); if (!box) return;
  function money(cents) { try { return new Intl.NumberFormat('en-CA', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD' }).format(cents / 100).replace(/\.00$/, ''); } catch (e) { return '$' + (cents / 100).toFixed(2); } }
  var lastOffer;
  window.lumShipLine = function (price, localOnly, available) {
    lastOffer = [price, localOnly, available];
    box.setAttribute('data-available', available ? 'true' : 'false');
    var cutEl = box.querySelector('[data-pdp-cutoff]');
    if (cutEl) { cutEl.textContent = (localOnly ? 'Eligible HRM local delivery or store pickup' : 'Shipping, eligible HRM local delivery or store pickup') + ': availability and timing confirmed at checkout.'; cutEl.hidden = !available; }
    var line = box.querySelector('[data-pdp-shipline]'); if (!line) return;
    line.hidden = !available;
    var cartBox = document.querySelector('[data-cart-how]');
    var drawer = document.getElementById('CartDrawer');
    var method = (cartBox && cartBox.getAttribute('data-fulfillment-value')) || (drawer && drawer.getAttribute('data-fulfillment-preference'));
    var subtotal = cartBox ? cartBox.getAttribute('data-subtotal') : box.getAttribute('data-cart-sub');
    var quantity = document.querySelector('#ProductForm [name="quantity"]');
    var sub = Number(subtotal || 0) + Number(price || 0) * Math.max(1, Number(quantity && quantity.value) || 1);
    var toLocal = Number(box.getAttribute('data-free-local') || 0) - sub, toShip = Number(box.getAttribute('data-free-ship') || 0) - sub;
    var l = line.querySelector('[data-pdp-shipline-local]'), p = line.querySelector('[data-pdp-shipline-parcel]');
    if (l) {
      l.hidden = method === 'shipping' && !localOnly;
      l.textContent = method === 'pickup' ? 'Store pickup is free. Wait for your ready-for-pickup email.' : (toLocal <= 0 ? 'Adding this reaches the eligible HRM free local delivery threshold.' : 'Add this and you’re ' + money(toLocal) + ' from eligible HRM free local delivery.') + ' Local zones from $' + (Number(box.getAttribute('data-free-local')) / 100) + '; outer zones may differ. Address and timing confirmed at checkout.';
    }
    if (p) {
      p.hidden = !!localOnly || method === 'local_delivery' || method === 'pickup';
      p.textContent = (toShip <= 0 ? 'Adding this reaches the free parcel shipping threshold.' : 'Add this and you’re ' + money(toShip) + ' from free parcel shipping.') + ' Eligible orders from $' + (Number(box.getAttribute('data-free-ship')) / 100) + '. HRM local delivery has a separate $' + (Number(box.getAttribute('data-free-local')) / 100) + ' threshold. Restrictions apply; rates and timing confirmed at checkout.';
    }
  };
  var jsonEl = document.querySelector('[data-product-json]'), idInput = document.querySelector('[data-variant-id]'), details = {};
  try { details = JSON.parse((document.querySelector('[data-product-variant-details]') || {}).textContent || '{}'); } catch (e) {}
  try {
    var product = JSON.parse(jsonEl.textContent), v = product.variants.find(function (x) { return String(x.id) === String(idInput && idInput.value); }) || product.variants[0];
    var d = details[String(v.id)] || {};
    window.lumShipLine(v.price, !!d.localOnly, !!v.available);
  } catch (e) {}

  // "Only 1 left online" and "Low at Bedford" describe the same units: for a local
  // shopper they read as one line, "Only 1 left · at Bedford".
  window.lumMergeLeft = function () {
    var left = box.querySelector('[data-pdp-left]'), store = box.querySelector('.lum-pdp__stores'), n = box.querySelector('[data-pdp-left-n]');
    if (!left || !n) return;
    var names = store && store.getAttribute('data-stores'), local = document.documentElement.classList.contains('lum-local');
    var tail = left.querySelector('[data-pdp-left-tail]');
    if (!tail) { tail = document.createElement('span'); tail.setAttribute('data-pdp-left-tail', ''); left.appendChild(tail); var t = left.lastChild; left.textContent = ''; left.appendChild(document.createTextNode('Only ')); left.appendChild(n); left.appendChild(tail); }
    if (!left.hidden && local && names) { tail.textContent = ' left · at ' + names; store.hidden = true; }
    else { tail.textContent = ' left online'; if (store) store.hidden = false; }
  };
  window.lumMergeLeft();
  var cut = box.querySelector('[data-pdp-cutoff]'); if (!cut) return;
  cut.hidden = box.getAttribute('data-available') === 'false';
  function refreshFulfillment() { if (lastOffer) window.lumShipLine.apply(null, lastOffer); }
  document.addEventListener('luminate:cart-rendered', refreshFulfillment);
  document.addEventListener('change', function (event) { if (event.target.matches('#ProductForm [name="quantity"]')) refreshFulfillment(); });
})();
